import { useSearchFiltersStore } from '@aibees/elephant/feature/search-filters/store';
import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { useEffect } from 'react';

export function useResetCurrentFilterOnRouteChange() {
  const type = useSearchTypeFromRoute();
  const setCurrent = useSearchFiltersStore.useSetCurrent();

  useEffect(() => {
    setCurrent(false);
  }, [setCurrent, type]);
}
